import React from "react";

import AdaptiveCriticalImage from "../../atoms/AdaptiveCriticalImage";
import MultiplePara from "../../atoms//common/MultiplePara";
import TpWidgetMicro from "./TpWidgetMicro";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export default function HeroWithLayeredImages({
  data,
  sectionClassName,
  imageClassName = "",
  hasTpwidgetMicro = "false",
}) {
  const appMode = process.env.APP_MODE;
  const signupLink = data?.cta?.href?.[appMode] || data?.cta?.href;
  return (
    <section
      className={`container grid--default has-align-top hero--default lg:pb-10 md:pb-5 ${sectionClassName}`}
    >
      <article className="text-left lg:maxw-lg lg:mr-5">
        <h1 className="text-xl lg:pt-5">{data.title}</h1>
        <MultiplePara data={data.desc} />
        <a
          href={signupLink}
          className="btn-primary lg:mt-5 md:mt-2.5 md:mb-5 md:w-100"
          id="feature-page-hero-cta"
        >
          <span>{data.cta.text}</span>
        </a>
        {hasTpwidgetMicro && (
          <TpWidgetMicro className="trustpilot-widget-micro lg:mt-5" />
        )}
      </article>
      <picture>
        <AdaptiveCriticalImage
          src={data.images.fg.src}
          alt={data.images.fg.alt}
          mobile={data.images.fg.prefixes.mobile}
          dpi={data.images.fg.prefixes.dpi}
          className={`${imageClassName}`}
          dimensions={data.images.fg.dimensions}
        />
      </picture>
    </section>
  );
}
